import React, { useState } from "react";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";
import image1 from "../images/1.PNG";
import team1 from "../images/team1.jpg";
import team2 from "../images/team2.png";
import team3 from "../images/team3.jpg";
import team4 from "../images/team4.jpg";
import "../components/Service5.css";
import "../components/Service6.css";
import Footer from "./Footer";
import heroVideo from "../videos/hero_video.mp4";

export default function Services() {
  // Services with like counts
  const [services, setServices] = useState([
    { id: 1, icon: "fa-hammer", title: "Carpenter", color: "primary", likes: 0 },
    { id: 2, icon: "fa-border-all", title: "Tile Works", color: "warning", likes: 0 },
    { id: 3, icon: "fa-broom", title: "Cleaning", color: "success", likes: 0 },
    { id: 4, icon: "fa-faucet", title: "Plumbing", color: "info", likes: 0 },
  ]);

  // Team members
  const team = [
    { id: 1, name: "Joe Jackson", img: team1, role: "Kitchen Cleaner" },
    { id: 2, name: "Bill Clinton", img: team2, role: "House Cleaner" },
    { id: 3, name: "Dani Warne", img: team3, role: "Office Cleaner" },
    { id: 4, name: "Aaron Finch", img: team4, role: "Door Cleaner" },
  ];

  // Handle heart click
  const handleLike = (id) => {
    const updatedServices = services.map((service) =>
      service.id === id ? { ...service, likes: service.likes + 1 } : service
    );
    setServices(updatedServices);
  };

  return (
    <div>
      {/* Header Section */}
      
      <section
  id="header"
  className="jumbotron text-center text-white d-flex flex-column justify-content-center align-items-center"
  style={{
    height: "70vh",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* Video Background */}
  <video
    src={heroVideo}
    autoPlay
    loop
    muted
    playsInline
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      zIndex: -1,
    }}
  />

  {/* Header Content */}
  <h1 className="display-3 fw-bold">Our Services</h1>
  <p className="lead">
    Skilled professionals ready to handle your home and office needs.
  </p>
  <div>
    <a href="/Booking" className="btn btn-primary me-2">
      Get Started
    </a>
    <a href="/Learn" className="btn btn-secondary">
      Learn More
    </a>
  </div>
</section>


      {/* What We Offer Section */}
      <section id="gallery" className="py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">What We Offer</h2>
          <div className="row g-4 justify-content-center">
            {services.map((item) => (
              <div key={item.id} className="col-lg-3 col-md-6 col-sm-12">
                <div className="card shadow-sm border-0 h-100 text-center p-3 card-hover">
                  <div
                    className={`icon-circle bg-${item.color} text-white mx-auto mb-3`}
                  >
                    <i className={`fas ${item.icon} fa-2x`}></i>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title fw-bold">{item.title}</h5>
                    <p className="card-text flex-grow-1">
                      Professional, fast, and reliable service for your needs.
                    </p>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <a
                        href="/services-details"
                        className="btn btn-outline-success btn-sm"
                      >
                        Read More
                      </a>
                      <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => handleLike(item.id)}
                      >
                        <i className="far fa-heart"></i> {item.likes}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Like Summary Section */}
      <section className="like-summary py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-4">Total Likes Summary</h2>
          <div className="row g-4 justify-content-center">
            {services.map((item) => (
              <div key={item.id} className="col-lg-3 col-md-6 col-sm-12">
                <div className="card shadow-sm border-0 text-center p-3">
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="mb-0">
                    <i className="far fa-heart text-danger me-2"></i>
                    {item.likes} Likes
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <div className="position-relative">
                <img src={image1} alt="FAQ" className="img-fluid rounded shadow" />
                <div className="contact-box bg-warning p-4 shadow position-absolute bottom-0 start-50 translate-middle-x text-center rounded">
                  <i className="fas fa-phone fa-2x mb-3 text-dark"></i>
                  <h6 className="mb-1">Tell Us</h6>
                  <h5 className="fw-bold">+94 771234567</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h6 className="text-uppercase text-primary fw-bold">FAQ</h6>
              <h2 className="fw-bold mb-4">Get Clear Solution Answer FAQ.</h2>
              <div className="accordion" id="faqAccordion">
                {[{
                    id: "faq1",
                    question: "01. What do you clean before cleaning?",
                    answer: "We ensure all areas are properly prepared for efficient and thorough cleaning.",
                  },
                  {
                    id: "faq2",
                    question: "02. How much is a cleaner per hour?",
                    answer: "Our rates are affordable and depend on the service type and duration.",
                  },
                  {
                    id: "faq3",
                    question: "03. Do you pay cleaners before or after?",
                    answer: "Payment can be made before or after service completion depending on your plan.",
                  },
                ].map((faq, index) => (
                  <div key={faq.id} className="accordion-item mb-2 border-0 shadow-sm">
                    <h2 className="accordion-header">
                      <button
                        className={`accordion-button fw-semibold ${index !== 0 ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#${faq.id}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={faq.id}
                      className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body">{faq.answer}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section py-5">
        <div className="container text-center">
          <h6 className="text-success">Our Team</h6>
          <h2 className="fw-bold mb-5">
            Talented Members Ready To <br /> Start Your Project
          </h2>
          <div className="row g-4">
            {team.map((member) => (
              <div key={member.id} className="col-lg-3 col-md-6 col-sm-12">
                <Link to="/team" className="text-decoration-none text-dark">
                  <div className="card border-0 shadow-sm team-card">
                    <img src={member.img} alt={member.name} className="card-img-top team-img" />
                    <div className="card-body text-start">
                      <p className="text-success fw-semibold mb-1">{member.role}</p>
                      <h5 className="fw-bold mb-0">{member.name}</h5>
                      <div className="float-end">
                        <i className="fas fa-share-nodes text-secondary"></i>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WhatsApp Section */}
      <div className="whatsapp-wrapper d-flex justify-content-center">
        <div className="whatsapp-section text-center py-5 px-4">
          <h3 className="fw-bold mb-3 text-white">
            Chat with Us on WhatsApp <br /> Get Instant Support
          </h3>
          <div className="d-flex justify-content-center">
            <a
              href="https://wa.me/94771234567"
              target="_blank"
              rel="noopener noreferrer"
              className="btn whatsapp-btn fw-bold px-4 py-2 d-flex align-items-center gap-2"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
